export default "/img/VG.2ba68da23efdfe660ab49048fdbc6018.png";